import { type RefObject, useEffect } from 'react';

import { is } from 'utils/helpers';

/** Trigger a callback when clicking outside of the specified container. */
export function useOutsideClick<T extends HTMLElement>(
	containerRef: RefObject<T | null> | undefined,
	callback: (e: DocumentEventMap['click']) => void,
) {
	const handleClick = (e: DocumentEventMap['click']) => {
		// If offsetParent is null the ref element is hidden and we should not act
		if (
			containerRef?.current &&
			is.node(e.target) &&
			!containerRef.current.contains(e.target) &&
			containerRef.current.offsetParent
		) {
			callback(e);
		}
	};

	useEffect(() => {
		document.addEventListener('click', handleClick);

		return () => {
			document.removeEventListener('click', handleClick);
		};
	});
}
